export type OrdersStatusMessages = {
  confirmedOption: string;
  paidOption: string;
  handlingOption: string;
  invoicedOption: string;
  shippedOption: string;
  draftOption: string;
  deliveredOption: string;
  waitingOption: string;
  cancelledOption: string;
  errorOption: string;
  statusUnknown: string;
  cancellationRequestOption: string;
};

export const ORDERS_STATUS_MESSAGES: OrdersStatusMessages = {
  confirmedOption: "Pedido confirmado",
  paidOption: "Pedido pago",
  handlingOption: "Em manuseio",
  invoicedOption: "Pedido faturado",
  shippedOption: "Pedido enviado",
  draftOption: "Rascunho",
  deliveredOption: "Pedido entregue",
  waitingOption: "Aguardando processamento",
  cancelledOption: "Pedido cancelado",
  errorOption: "Erro no processamento",
  statusUnknown: "Status desconhecido",
  cancellationRequestOption: "Solicitação de cancelamento",
};
